export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="fs-g" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#e6e8ec" />
        <stop offset="1" stopColor="#8b929c" />
      </linearGradient>
    </defs>
    <rect x="6" y="6" width="32" height="32" rx="6" fill="none" stroke="#fff" strokeOpacity=".6" strokeWidth="3.5" />
    <rect x="24" y="24" width="34" height="34" rx="6" fill="url(#fs-g)" />
    <path d="M33 49 L49 33" stroke="#050505" strokeWidth="4.5" strokeLinecap="round" />
    <path d="M40 33 H49 V42" fill="none" stroke="#050505" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Wordmark = ({ testId = "nav-logo", onClick, className = "h-9 sm:h-11" }) => (
  <button data-testid={testId} onClick={onClick} className="group shrink-0" aria-label="Frame Shift home">
    <img src="/images/logo-wordmark.png" alt="Frame Shift" className={`${className} w-auto transition-[filter] duration-500 group-hover:drop-shadow-[0_0_12px_rgba(230,232,236,0.6)]`} draggable={false} />
  </button>
);

export const Logo = ({ testId = "nav-logo", onClick }) => (
  <button data-testid={testId} onClick={onClick} className="flex items-center gap-3 group" aria-label="Frame Shift home">
    <LogoMark className="h-8 w-8 transition-transform duration-500 group-hover:rotate-[-8deg]" />
    <span className="font-display text-[15px] font-bold tracking-tight">
      FRAME<span className="text-[#e6e8ec]">/</span>SHIFT
    </span>
  </button>
);
